"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _classnames = _interopRequireDefault(require("classnames"));

var _icons = require("@material-ui/icons");

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _reactI18next = require("react-i18next");

var _withStyles = _interopRequireDefault(require("@material-ui/styles/withStyles"));

var CustomIconButton = function CustomIconButton(props) {
  var classes = props.classes,
      rest = (0, _objectWithoutProperties2["default"])(props, ["classes"]);
  return /*#__PURE__*/_react["default"].createElement(_core.IconButton, (0, _extends2["default"])({}, rest, {
    className: "".concat(classes.root, " duration-200 ease-in-out transition-all")
  }));
};

var StyledIconButton = (0, _withStyles["default"])(function (theme) {
  return {
    root: {
      position: 'relative',
      left: -16,
      top: '1rem',
      width: 32,
      height: 32,
      transitionProperty: 'background-color',
      backgroundColor: theme.palette.app.divider,
      '&:hover': {
        backgroundColor: theme.palette.app.divider,
        color: theme.palette.text['primary-active']
      }
    }
  };
})(CustomIconButton);

var Container = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var theme = _ref.theme,
      leftContent = _ref.leftContent,
      drawerContent = _ref.drawerContent,
      drawerOpen = _ref.drawerOpen,
      onToggleDrawer = _ref.onToggleDrawer;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var tooltipCollapseText = t('tooltip.collapse');
  var tooltipExpandText = t('tooltip.expand');
  var onToggle = (0, _react.useCallback)(function () {
    onToggleDrawer(!drawerOpen);
  }, [drawerOpen]);

  var _useState = (0, _react.useState)(!drawerOpen),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showToggle = _useState2[0],
      setShowToggle = _useState2[1];

  var onShowDrawerToggle = (0, _react.useCallback)(function () {
    setShowToggle(true);
  }, [setShowToggle]);
  var onHideDrawerToggle = (0, _react.useCallback)(function () {
    if (drawerOpen) {
      setShowToggle(false);
    }
  }, [setShowToggle, drawerOpen]);
  var drawerEdgeClassName = (0, _react.useMemo)(function () {
    return (0, _classnames["default"])('select-none z-50 h-full overflow-x-visible duration-200 ease-in-out transition-all absolute w-0 right-0 top-0', {
      'w-px': drawerOpen,
      'w-4 bg-secondary dark:bg-card shadow-lg dark:shadow-shallow': !drawerOpen
    });
  }, [drawerOpen]);
  var drawerButtonClassName = (0, _react.useMemo)(function () {
    return (0, _classnames["default"])('z-0 flex-shrink-0 overflow-x-visible transition-all duration-500 ease-in-out ', {
      'overflow-y-scroll': drawerOpen,
      'overflow-y-hidden': !drawerOpen
    });
  }, [drawerOpen]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex h-screen flex-row-reverse"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "z-10 relative dark:shadow-deep-r flex flex-grow overflow-x-visible transition-all duration-500 ease-in-out",
    style: {
      maxWidth: drawerOpen ? 'calc(100% - 400px)' : '100%',
      order: 2,
      boxShadow: theme.isDarkTheme ? undefined : '0 0px 20px rgba(0,0,0,.035), 0 0px 20px rgba(0,0,0,.035)',
      width: 'calc(100% - 400px)',
      overflow: drawerOpen ? 'visible' : 'hidden'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full z-0",
    style: {
      width: drawerOpen ? '100%' : 'calc(100% - 1rem)'
    }
  }, leftContent), /*#__PURE__*/_react["default"].createElement("div", {
    className: drawerEdgeClassName,
    onMouseEnter: onShowDrawerToggle,
    onMouseLeave: onHideDrawerToggle
  }, showToggle && /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: drawerOpen ? tooltipCollapseText : tooltipExpandText
  }, /*#__PURE__*/_react["default"].createElement(StyledIconButton, {
    onClick: onToggle,
    drawerOpen: drawerOpen
  }, !drawerOpen && /*#__PURE__*/_react["default"].createElement(_icons.ChevronLeft, null), drawerOpen && /*#__PURE__*/_react["default"].createElement(_icons.ChevronRight, null))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: drawerButtonClassName,
    style: {
      width: drawerOpen ? 400 : 0
    },
    onMouseEnter: onShowDrawerToggle,
    onMouseLeave: onHideDrawerToggle
  }, drawerContent));
});

var _default = Container;
exports["default"] = _default;
//# sourceMappingURL=ContainerWithRightDrawer.js.map